import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { Box, Typography, Button } from '@mui/material';
export class ErrorBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    gap: 2,
                }, children: [_jsx(Typography, { variant: "h4", children: "Something went wrong" }), _jsx(Typography, { sx: {
                            color: "text.secondary"
                        }, children: this.state.error?.message || 'An unexpected error occurred' }), _jsx(Button, { variant: "contained", onClick: () => window.location.reload(), children: "Reload Page" })] }));
        }
        return this.props.children;
    }
}
